import { render, staticRenderFns } from "./PrivacyPolicyDefault.vue?vue&type=template&id=f9e55db8&scoped=true"
import script from "./PrivacyPolicyDefault.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyDefault.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicyDefault.vue?vue&type=style&index=0&id=f9e55db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e55db8",
  null
  
)

export default component.exports